import API from "./API";

export const multipleFileUploadApi = async (payload) => {
  try {
    const formData = new FormData();

    payload.files.forEach((file) => {
      formData.append("files", file); // important
    });
    if (payload?.productId) {
      formData.append("productId", payload?.productId.toString());
    }

    console.log("formData ", formData, payload.files);

    const response = await API.post(`/api/product/upload/files`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFileApi = async (payload) => {
  try {
    const response = await API.delete(
      `/api/product/file?key=${payload?.key || ""}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductApi = async (payload) => {
  try {
    const response = await API.get(
      `/api/products/all?page=${payload?.page || 0}&size=${payload?.size || 10}&search=${payload?.keyword || ''}&sortDir=${payload?.sortdir || ''}&isActive=${payload?.isActive || ''}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSellerProductApi = async (payload) => {
  try {
    const response = await API.get(
      `/api/user/products?page=${payload?.page || 0}&size=${payload?.size || 10}&search=${payload?.keyword || ''}&sortDir=${payload?.sortdir || ''}&isActive=${payload?.isActive || ''}&sku=${payload?.sku || ''}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleProductApi = async (payload) => {
  try {
    const response = await API.get(`/api/product/${payload?.productId || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadProductApi = async (payload) => {
  try {
    const response = await API.post(
      `/api/product?brandId=${payload?.brandId || null}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductApi = async (payload) => {
  try {
    const response = await API.put(`/api/product`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductApi = async (payload) => {
  try {
    const response = await API.delete(`/api/product/${payload?.productId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const activationProductApi = async (payload) => {
  try {
    const response = await API.put(
      `/api/product/${payload?.productId || 0}/active?isActive=${
        payload?.isActive
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllColorsApi = async (payload) => {
  try {
    const response = await API.get(
      `/api/products/all?page=${payload?.page || 0}&size=${payload?.size || 10}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadColorApi = async (payload) => {
  try {
    const response = await API.post(
      `/api/product/color?productId=${payload?.productId || 1}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateColorApi = async (payload) => {
  try {
    const response = await API.put(
      `/api/product/color?productId=${payload?.productId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllSizesApi = async (payload) => {
  try {
    const response = await API.get(
      `/api/products/all?page=${payload?.page || 0}&size=${payload?.size || 10}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadSizeApi = async (payload) => {
  try {
    const response = await API.post(
      `/api/product/color/size?colorId=${payload?.colorId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSizeApi = async (payload) => {
  try {
    const response = await API.put(
      `/api/product/color/size?colorId=${payload?.colorId || 0}`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};
